import { untrack } from "~/tools/impulse";
import { SessionStorage } from "~/tools/session-storage";

const LAST_CONVERSATION_ID = "__sts_ai_drawer_last_conversation_id__";

export const getLastConversationId = (): string | undefined =>
	untrack((scope) => SessionStorage.getItem(scope, LAST_CONVERSATION_ID));

export const setLastConversationId = (conversationId: string | undefined): void => {
	SessionStorage.setItem(LAST_CONVERSATION_ID, conversationId);
};
